export default __webpack_public_path__ + "static/media/Thief's Mask of the Smoldering Throne.90aa4d5a.jpg";